export default __webpack_public_path__ + "static/media/ayelet_goldfarb_frank.9b63243d.jpeg";